module.exports = __webpack_public_path__ + "assets/img/img269.2408f827.png";